import {
  START_LOAD_ALL_CHARTS,
  SUCCESS_LOAD_ALL_CHARTS,
  ERROR_LOAD_ALL_CHARTS,
  DATE_CHANGE_ALL_CHARTS,
} from 'store/actions/charts'

import {dateFormatISO} from 'shared/dateFormat'

import {isEmpty} from 'lodash'
import {endOfToday, startOfYear} from 'date-fns'

const currentDate = new Date()
const defaultDateRange = {
  from: dateFormatISO(startOfYear(currentDate)),
  to: dateFormatISO(endOfToday(currentDate)),
}

const initialState = {
  cumulativeProductionBudget: {
    nameChart: '',
    y1Name: '',
    y2Name: '',
    y1AvgName: '',
    y2AvgName: '',
    y1Avg: '',
    y2Avg: '',
    data: [],
  },
  productionBudget: {
    nameChart: '',
    y1Name: '',
    y2Name: '',
    y1AvgName: '',
    y2AvgName: '',
    y1Avg: '',
    y2Avg: '',
    data: [],
  },
  averageDailyInsolation: {
    nameChart: '',
    y1Name: '',
    y2Name: '',
    y1AvgName: '',
    y2AvgName: '',
    y1Avg: '',
    y2Avg: '',
    data: [],
  },
  energyAvailability: {
    nameChart: '',
    y1Name: '',
    y2Name: '',
    y1AvgName: '',
    y2AvgName: '',
    y1Avg: '',
    y2Avg: '',
    data: [],
  },
  dateRange: defaultDateRange,
  isLoading: false,
  isLoaded: false,
  isError: false,
}
const charts = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD_ALL_CHARTS: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case SUCCESS_LOAD_ALL_CHARTS: {
      const {data} = action
      console.log(data, 'SUCCESS_LOAD_ALL_CHARTS')

      return {
        ...state,
        ...data,
        isLoading: false,
        isLoaded: !isEmpty(data),
      }
    }
    case DATE_CHANGE_ALL_CHARTS: {
      return {
        ...state,
        dateRange: {...state.dateRange, ...action.dateRange},
      }
    }
    case ERROR_LOAD_ALL_CHARTS: {
      return {
        ...state,
        isError: true,
      }
    }
    default:
      return state
  }
}

export default charts
